module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAABHNCSVQICAgIfAhkiAAAAKBJREFUSInt1jEOgkAURVEiy2ApWhLtLGxt3IzuzMKdWEhLNCYcGxIMIurMJDa8fm7+ffOLn2GHG85YZrFBrUuDA/IY4N1rjihCgRtUA9AKZSi0aKfqJ7wC5O3jJnUF5VTBVMFoBfNQaIHTALSeBRHfpw6Zbkx5/Qsoxz7JpyRdmw+K3y/2pPhfxUUSxSfgNVqxB7xEKQ4At7pTZBUMavMAZJYctkv4iCoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/next.png
// module id = liws
// module chunks = 1